export default __webpack_public_path__ + "static/media/RightArrow.8bdbf367.svg";